export default {
  id: 20,
  pride: 13312,
  slug: "travel-compass",
  category: "tool",
  status: "released",
  experienceable: true,
  titleKey: {
    zh: "旅路罗盘",
    en: "Travel Compass"
  },
  image: require('@/assets/images/travel_compass.webp'),
  descriptionKey: {
    zh: "个人导航站。一个纯静态、预设导航链接的导航站。",
    en: "Personal navigation site. A purely static navigation site with preset navigation links."
  },
  date: { year: 2025, month: 2 },
  genres: ["导航站", "工具"],
  themes: ["效率", "整理"],
  engine: "Web",
  platform: ["Web"],
  tags: ["自用工具"],
  longDescriptionKey: {
    zh: "",
    en: ""
  },
  links: [
    { type: "web", url: "https://start.tobenot.top/", textKey: { zh: "访问导航站", en: "Visit Navigation Site" } }
  ]
};
